import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import affiliate_api from "../api/public/affiliates"

// TODO: This needs to be possible to sort for any redirect - e.g home, about, etc
const AffiliateRedirect = () => {
    const { affiliateName } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (affiliateName) {
            affiliate_api
                .setAffiliate(affiliateName)
                .catch((err) => console.error("Failed to set affiliate cookie:", err))
                .finally(() => {
                    // Always redirect to home
                    navigate("/", { replace: true });
                });
        } else {
            navigate("/", { replace: true });
        }
    }, [affiliateName, navigate]);

    return null; // nothing to render
};

export default AffiliateRedirect;